"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDirections = void 0;
const axios_1 = __importDefault(require("axios"));
async function getDirections(userId, arrivalTimestamp, destination) {
    const resp = await (0, axios_1.default)({
        method: 'post',
        url: '/https2-travel/api/travel/directions',
        data: {
            userId,
            arrivalTimeUnixTimestamp: new Date(arrivalTimestamp).getTime() / 1000,
            destination
        }
    });
    return resp.data;
}
exports.getDirections = getDirections;
